import { cn } from '../../utils'
import { getIconSizeClasses, getVariantClasses } from './Icon.styles'
import { IconProps } from './Icon.types'

/**
 * @param variant - Default: "contained"
 * @param color - Default: "primary"
 * @param size - Default: "base"
 * @param viewBox - Default: "0 0 30 30"
 * @param stroke - Default: "stroke-current"
 * @param className - Default: ""
 * @param children - Default: ""
 */

export const Icon = ({
    className,
    stroke,
    children,
    size = 'base',
    color = 'primary',
    variant = 'primary',
    viewBox = '0 0 30 30',
    onClick,
    role,
    ...props
}: IconProps) => {
    const classes = cn(
        getIconSizeClasses(size),
        getVariantClasses(variant, color)
    )
    return (
        <div
            className={cn(className, classes)}
            {...props}
            role={role}
            onClick={onClick}
        >
            <svg
                className={cn(stroke)}
                viewBox={viewBox}
                xmlns="http://www.w3.org/2000/svg"
            >
                {children}
            </svg>
        </div>
    )
}
